import React from 'react';

import { useIntl } from 'react-intl';
import { View } from 'react-native';

import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { useLocale } from 'state/intl';

import { FooterCCPAButtonLink, FooterText, FooterWrapper } from './footer.styled';

export const Footer = () => {
  const { formatMessage } = useIntl();
  const { region } = useLocale();
  const isDesktopLarge = useIsDesktopLargeBreakpoint();
  return (
    <FooterWrapper>
      <View focusable>
        <FooterText>
          {formatMessage(
            { id: 'trademarkAndCopyright' },
            { year: String(new Date().getFullYear()) }
          )}{' '}
          {formatMessage({ id: 'allRightsReserved' })}
        </FooterText>
      </View>
      {isDesktopLarge && region === 'US' && <FooterText> | </FooterText>}
      {region === 'US' && <FooterCCPAButtonLink isUnderlined isInline={isDesktopLarge} />}
    </FooterWrapper>
  );
};
